import { render, staticRenderFns } from "./NotificationsDocumentsDetail.vue?vue&type=template&id=54dc86a0&scoped=true&"
import script from "./NotificationsDocumentsDetail.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDocumentsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc86a0",
  null
  
)

export default component.exports